import { cls } from "@utdanningsdirektoratet/utils/cls";
import { onKeyDown } from "@utdanningsdirektoratet/utils/uu";
import { Icon } from "@utdanningsdirektoratet/icon";
import styles from "./RichText.module.less";

type CommentsProps = {
  id: string;
  isOpen: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

const Comments: React.FC<CommentsProps> = ({ id, isOpen, setOpen }) => {
  const iconClassName = cls({
    [styles.richTextCommentsSidebarButtonIcon]: true,
    [styles.richTextCommentsSidebarButtonIconOpen]: isOpen,
  });

  const sidebarClassName = cls({
    [styles.richTextCommentsSidebar]: true,
    [styles.richTextCommentsSidebarOpen]: isOpen,
  });

  return (
    <div className={sidebarClassName}>
      <div
        role="button"
        tabIndex={0}
        aria-expanded={isOpen}
        aria-controls={`annotations-wrapper-${id}`}
        onClick={() => setOpen((prev) => !prev)}
        onKeyDown={onKeyDown(() => setOpen((prev) => !prev))}
        className={styles.richTextCommentsSidebarButton}
      >
        <Icon className={iconClassName} icon="angle left double" />
      </div>
      <div className="sidebar" id={`sidebar-${id}`}>
        {/* NB: denne id'en brukes i RichText til å kunne selecte elementet */}
        <div aria-hidden={!isOpen} className="annotations-wrapper" id={`annotations-wrapper-${id}`}></div>
      </div>
    </div>
  );
};

export default Comments;
